import React, { Component } from "react";
import notificationIcon from "../images/notification-decor-icon.png";
import notificationUnread from "../images/notification-unread-icon.png";
import Close from "@material-ui/icons/Close";
// import ExpansionPanel from "@material-ui/core/ExpansionPanel";
// import ExpansionPanelSummary from "@material-ui/core/ExpansionPanelSummary";
// import ExpansionPanelDetails from "@material-ui/core/ExpansionPanelDetails";
import Accordion from '@mui/material/Accordion';
import AccordionDetails from '@mui/material/AccordionDetails';
import AccordionSummary from '@mui/material/AccordionSummary';

import ClipLoader from "react-spinners/ClipLoader";
import defaultImg from "../images/defaultimg.png";
import vendor from "../images/vendor.png";
import item from "../images/item.png";
import code from "../images/code.png";
import price from "../images/money.png";
import description from "../images/description.png";
import quantity from "../images/quantity.png";
import Repo from "../Repository/Repo";
import {
  Box,
  TextField,
  Dialog,
  DialogActions,
  DialogContent,
} from "@mui/material";

import { Typography } from "@mui/material";

class Notifications extends Component {
  constructor() {
    super();
    this.state = {
      notifications: [],
      state: true,
      loading: true,
      noNotifications: "",
      showDialog: false,
      detailedNotification: {},
    };
  }

  componentWillMount() {
    this.refreshNotifications();
    // localStorage.removeItem('selectedToSale');
    // localStorage.removeItem('items');
    // localStorage.removeItem('itemsForSearch');
  }

  refreshNotifications() {
    Repo.notification({
      request: {
        method: "getNotifications",
        data: {
          company_code: localStorage.getItem("companyCode"),
        },
      },
    }).then((res) => {
      this.setState({ loading: false });
      let { notifications } = this.state;

      notifications = [];

      if (res.data.response.data.notifications.length == 0) {
        this.setState({ noNotifications: "No Notifications" });
        return;
      } else {
        this.setState({ noNotifications: "" });
      }

      res.data.response.data.notifications.map((item) => {
        notifications.push(item);
      });

      console.log(notifications);

      this.setState({ notifications });
    });
  }

  updateNotification(
    id,
    rev,
    data,
    timestamp,
    item_id,
    itemId,
    quantity,
    minQuantity,
    description,
    url,
    dateOfPurchase,
    price,
    salePrice,
    vendor,
    name,
    itemCode
  ) {
    Repo.notification({
      request: {
        method: "updateNotification",
        data: {
          notification: {
            _id: id,
            _rev: rev,
            data: data,
            item_id: item_id,
            timestamp: timestamp,
            read: true,
            company_code: localStorage.getItem("companyCode"),
            itemId: itemId,
            quantity: quantity,
            minQuantity: minQuantity,
            description: description,
            imgURL: url,
            dateOfPurchase: dateOfPurchase,
            price: price,
            salePrice: salePrice,
            vendor: vendor,
            name: name,
            itemCode: itemCode,
          },
        },
      },
    }).then((res) => {
      this.refreshNotifications();
    });
  }

  deleteNotification(id, rev) {
    Repo.notification({
      request: {
        method: "deleteNotification",
        data: {
          _id: id,
          company_code: localStorage.getItem("companyCode"),
        },
      },
    }).then((res) => {
      console.log(res);
      this.refreshNotifications();
    });
  }

  showDetails(notification) {
    this.setState({ showDialog: true });
    this.setState({ detailedNotification: notification });
    console.log("sjh");
  }

  timeConverter(UNIX_timestamp) {
    var a = new Date(UNIX_timestamp * 1000);
    var months = [
      "1",
      "2",
      "3",
      "4",
      "5",
      "6",
      "7",
      "8",
      "Sep",
      "Oct",
      "Nov",
      "12",
    ];
    var year = a.getFullYear();
    var month = months[a.getMonth()];
    var date = a.getDate();
    var time = date + "-" + month + "-" + year;
    return time;
  }

  render() {
    if (
      localStorage.getItem("token") == null ||
      localStorage.getItem("tokenType") != "admin"
    ) {
      window.location.reload();
    }
    return (
      <Box
        sx={{ mt: { md: "0px", xs: "40px" }, ml: { md: "0px", xs: "16px" } }}
      >
        <div className="center">
          <Typography
            className="green"
            sx={{ fontSize: { md: "2.125rem", xs: "16px" } }}
          >
            NOTIFICATIONS
          </Typography>
        </div>

        <div className="center">
          <ClipLoader
            size={50}
            color={"#4DAF51"}
            loading={this.state.loading}
          />
          <h2 className="regular green">{this.state.noNotifications}</h2>
          {this.state.notifications.map((notification) => {
            if (notification.read === true) {
              return (
                <Accordion>
                  <AccordionSummary>
                    <div className="no-margin-padding">
                      <img
                        className="notification-img"
                        src={
                          notification.imgURL == undefined
                            ? defaultImg
                            : notification.imgURL ==
                              "https://ats-bucket-hardware.s3.amazonaws.com/photos/undefined"
                            ? defaultImg
                            : notification.imgURL
                        }
                      />
                    </div>
                    <div style={{ paddingTop: "10px" }}>
                      <div style={{ textAlign: "left" }}>
                        <h3 className="regular no-margin-padding">
                          {notification.data}
                        </h3>
                      </div>
                      <div style={{ textAlign: "left" }}>
                        <h3 className="green regular no-margin-padding">
                          {this.timeConverter(notification.timestamp)}
                        </h3>
                      </div>
                    </div>
                  </AccordionSummary>
                  <AccordionDetails>
                    <div className="notification-details-container">
                      <hr className="no-margin-padding"></hr>
                      <div
                        style={{
                          position: "relative",
                          display: "block",
                          justifyContent: "center",
                        }}
                      >
                        <h4 className="green">Details</h4>
                        <div
                          className="noti-btn"
                          onClick={() => {
                            this.setState({ showDialog: true });
                            this.setState({
                              detailedNotification: notification,
                            });
                            console.log("sjh");
                          }}
                        >
                          See More
                        </div>
                      </div>

                      <div className="notification-details ">
                        <div className="flex">
                          <p className="no-margin-padding">Min Quantity: </p>
                          <p className="bold padding-left no-margin-padding">
                            {notification.minQuantity}
                          </p>
                        </div>
                        <div className="flex">
                          <p className="no-margin-padding">
                            Current Quantity:{" "}
                          </p>
                          <p className="bold padding-left no-margin-padding">
                            {notification.quantity}
                          </p>
                        </div>
                        <div className="flex">
                          <p className="no-margin-padding">
                            Stock is short by items:{" "}
                          </p>
                          <p className="bold padding-left no-margin-padding">
                            {notification.minQuantity - notification.quantity}
                          </p>
                        </div>
                      </div>
                    </div>
                  </AccordionDetails>
                </Accordion>
              );
            } else if (notification.read !== true) {
              return (
                <div
                  onClick={this.updateNotification.bind(
                    this,
                    notification._id,
                    notification._rev,
                    notification.data,
                    notification.timestamp,
                    notification.item_id,
                    notification.itemId,
                    notification.quantity,
                    notification.minQuantity,
                    notification.description,
                    notification.imgURL,
                    notification.dateOfPurchase,
                    notification.price,
                    notification.salePrice,
                    notification.vendor,
                    notification.name,
                    notification.itemCode
                  )}
                  className="notification-box-unread"
                >
                  <img
                    className="notification-img-unread "
                    src={
                      notification.imgURL ==
                      "https://ats-bucket-hardware.s3.amazonaws.com/photos/undefined"
                        ? defaultImg
                        : notification.imgURL
                    }
                    alt="icon"
                  ></img>
                  <div style={{ textAlign: "left", paddingTop: "10px" }}>
                    <h3 className="regular no-margin-padding">
                      {notification.data}
                    </h3>
                    <h3 className="green regular no-margin-padding">
                      {this.timeConverter(notification.timestamp)}
                    </h3>
                  </div>

                  <img
                    className="notification-icon-unread"
                    src={notificationUnread}
                    alt="unread"
                  ></img>
                </div>
              );
            }
          })}
        </div>

        <Dialog
          fullWidth="true"
          open={this.state.showDialog}
          onClose={() => {
            this.setState({ showDialog: false });
          }}
          aria-labelledby="form-dialog-title"
        >
          <p className="form-dialog-title">Item Details</p>
          <DialogContent>
            <div>
              <div className="text-field">
                <TextField
                  autoFocus
                  margin="dense"
                  id="name"
                  label="Name"
                  type="text"
                  value={this.state.detailedNotification.name}
                  fullWidth
                  InputProps={{ disableUnderline: true }}
                />
                <div>
                  <img
                    className="textfield-img"
                    src={item}
                    alt="description-img"
                  ></img>
                </div>
              </div>

              <div className="text-field">
                <TextField
                  margin="dense"
                  id="description"
                  label="Description"
                  type="text"
                  value={this.state.detailedNotification.description}
                  fullWidth
                  InputProps={{ disableUnderline: true }}
                />
                <div>
                  <img
                    className="textfield-img"
                    src={description}
                    alt="description-img"
                  ></img>
                </div>
              </div>

              <div className="text-field">
                <TextField
                  margin="dense"
                  id="description"
                  label="Quantity"
                  type="Number"
                  value={this.state.detailedNotification.quantity}
                  fullWidth
                  InputProps={{ disableUnderline: true }}
                />
                <div>
                  <img
                    className="textfield-img"
                    src={quantity}
                    alt="quantity-img"
                  ></img>
                </div>
              </div>

              <div className="text-field">
                <TextField
                  margin="dense"
                  id="description"
                  label="Min Quantity"
                  type="Number"
                  value={this.state.detailedNotification.minQuantity}
                  fullWidth
                  InputProps={{ disableUnderline: true }}
                />
                <div>
                  <img
                    className="textfield-img"
                    src={quantity}
                    alt="quantity-img"
                  ></img>
                </div>
              </div>

              <div className="text-field">
                <TextField
                  margin="dense"
                  label="Item Code"
                  type="text"
                  value={this.state.detailedNotification.itemCode}
                  fullWidth
                  InputProps={{ disableUnderline: true }}
                />
                <div>
                  <img className="textfield-img" src={code} alt="code"></img>
                </div>
              </div>

              <div className="flex-justify no-margin-padding">
                <div className="text-field">
                  <TextField
                    margin="dense"
                    label="Cost Price"
                    type="Number"
                    value={this.state.detailedNotification.price}
                    fullWidth
                    InputProps={{ disableUnderline: true }}
                  />
                  <div>
                    <img
                      className="textfield-img"
                      src={price}
                      alt="price"
                    ></img>
                  </div>
                </div>

                <div className="text-field">
                  <TextField
                    margin="dense"
                    label="Sale Price"
                    type="Number"
                    value={this.state.detailedNotification.salePrice}
                    fullWidth
                    InputProps={{ disableUnderline: true }}
                  />

                  <div>
                    <img
                      className="textfield-img"
                      src={price}
                      alt="price"
                    ></img>
                  </div>
                </div>
              </div>

              <div className="text-field">
                <TextField
                  margin="dense"
                  label="Vendor"
                  type="text"
                  value={this.state.detailedNotification.vendor}
                  fullWidth
                  InputProps={{ disableUnderline: true }}
                />
                <div>
                  <img className="textfield-img" src={vendor} alt="price"></img>
                </div>
              </div>

             
            </div>
          </DialogContent>

          <DialogActions className="dialog-btns">
            <div className="dialog-btn-container">
              <button
                className="dialog-btn-secondary"
                onClick={() => {
                  this.setState({ showDialog: false });
                }}
                color="primary"
              >
                Cancel
              </button>
            </div>
          </DialogActions>
        </Dialog>
      </Box>
    );
  }
}

export default Notifications;
